import * as React from 'react';

// mui
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

export default function Page404() {
    return (
        <Box>
            <Typography>該当URLがありません。</Typography>
        </Box>
    );
}